import { httpRequest } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

import { FinanceCategoriesResponse } from "@/types";

type Props = {
  search?: string | null
}

async function fetchFinanceCategories({ search }: Props): Promise<FinanceCategoriesResponse> {
  const response = await httpRequest.get<FinanceCategoriesResponse>(
    `/finance-categorie-entries?search=${search}`
  );
  return response.data;
}

export function useFetchFinanceCategoriesQuery({ search }: Props) {
  const categoriesResponseQuery = useQuery({
    queryKey: ["finance-categorie-entries", search],
    queryFn: () => fetchFinanceCategories({
      search
    }),
    keepPreviousData: true,
  });

  return {
    ...categoriesResponseQuery,
    data: categoriesResponseQuery?.data,
  };
}
